export type OfferItemKind = "included" | "bonus";

export interface OfferItem {
  kind: OfferItemKind;
  text: string;
}

export const offerItems: OfferItem[] = [
  {
    kind: "included",
    text: "+1.000 GIFs de musculación (listos para WhatsApp o cualquier otra aplicación de mensajería)",
  },
  {
    kind: "included",
    text: "Un paquete completo para transformar y corregir la ejecución de tus alumnos",
  },
  { kind: "bonus", text: "BONO 1 – Manual de Musculación" },
  { kind: "bonus", text: "BONO 2 – Guía de Ejecución Correcta" },
  { kind: "bonus", text: "BONO 3 – 150 Recetas Fitness" },
  { kind: "bonus", text: "BONO 4 – Planilla de Periodización Automatizada" },
  { kind: "included", text: "Soporte personalizado" },
  { kind: "included", text: "Garantía de 7 días" },
  { kind: "included", text: "Acceso de por vida y actualizaciones" },
];
